import { flexRender, Table } from '@tanstack/react-table'
import { TableBody, TableCell } from '../../../shared/components/ui/table'
import React from 'react'
import { HomeOwner } from '../types/backend-response.type'
import { cn } from '../../../shared/lib/utils'
import { Skeleton } from '../../../shared/components/ui/skeleton'
import TableRow from './table-row'


type HomeOwnersTableBodyProps = {
    table: Table<HomeOwner>,
    isLoading: boolean,
}

function HomeOwnersTableBody({ table, isLoading }: HomeOwnersTableBodyProps) {
    const colCount = table.getAllColumns().length
    const skeletonRows = 8

    if (isLoading) {
        return (
            <TableBody>
                {Array.from({ length: skeletonRows }).map((_, i) => (
                    <TableRow key={`skeleton-${i}`}>
                        {Array.from({ length: colCount }).map((_, j) => (
                            <TableCell key={j} className="py-4">
                                <Skeleton className="h-5 w-full max-w-[200px]" />
                            </TableCell>
                        ))}
                    </TableRow>
                ))}
            </TableBody>
        )
    }

    if(!isLoading && !table.getRowModel().rows.length) {
        return (
            <TableBody>
                <TableRow>
                    <TableCell
                        colSpan={table.getAllColumns().length} className="text-center"
                    >
                        <span className='text-muted-foreground mt-5 h-20'>
                            No data found
                        </span>
                    </TableCell>
                </TableRow>
            </TableBody>
        )
    }

    return (
        <TableBody>
            {table.getRowModel().rows.map(row => (
                <TableRow key={row.id}>
                    {row.getVisibleCells().map(cell => {
                        const printHide =
                            cell.column.id === 'select' ||
                            cell.column.id === 'actions'
                        return (
                        <TableCell
                            key={cell.id}
                            data-print-hide-col={printHide ? 'true' : undefined}
                            className={cn(
                                "py-4",
                                cell.column.id !== "actions" && cell.column.id !== "select" && "min-w-[150px] max-w-[350px]",
                                {
                                    "min-w-0 whitespace-nowrap pl-0": cell.column.id === "actions",
                                    "min-w-[30px]": cell.column.id === "select",
                                }
                            )}
                        >
                            {flexRender(
                                cell.column.columnDef.cell,
                                cell.getContext()
                            )}
                        </TableCell>
                        );
                    })}
                </TableRow>
            ))}
        </TableBody>
    )
}

export default HomeOwnersTableBody
